import { jsx } from "react/jsx-runtime";
import "react";
import { Box, Button } from "pcln-design-system";
const TripProtectionMarker = ()=>/*#__PURE__*/ jsx(Box, {
        ml: 3,
        mb: 4,
        children: /*#__PURE__*/ jsx(Button, {
            width: 1,
            size: 'small',
            children: "Add Trip Protection"
        })
    });
const TripProtectionMarker_TripProtectionMarker = TripProtectionMarker;
export { TripProtectionMarker_TripProtectionMarker as default };
